import lightBeige from './lightBeige.module.scss';
import lightGreen from './lightGreen.module.scss';
import lightMintGreen from './lightMintGreen.module.scss';
import lightPurple from './lightPurple.module.scss';
import lightYellow from './lightYellow.module.scss';
import mintGreen from './mintGreen.module.scss';

export { lightBeige, lightGreen, lightMintGreen, lightPurple, lightYellow, mintGreen };
